module.exports = __webpack_public_path__ + "static/media/line.07134f38.svg";